export default __webpack_public_path__ + "a9f9de63b701a49649f2081a4f24d7f6.png";